/**
 * useWorkstation — керування поточно вибраним POS-workstation через LocalStorage.
 *
 * Workstation для касира зберігається у LocalStorage (per-browser-device).
 * Касир обирає при першому вході. У hamburger menu — «Змінити робоче місце».
 *
 * Ключ: 'pos.workstation_id' — UUID.
 */
import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'pos.workstation_id';

export function useWorkstation() {
  const [workstationId, setWorkstationIdState] = useState<string | null>(() => {
    return localStorage.getItem(STORAGE_KEY);
  });

  // Sync з зовнішніми оновленнями (наприклад інша вкладка)
  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) {
        setWorkstationIdState(e.newValue);
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  const setWorkstationId = useCallback((id: string | null) => {
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    setWorkstationIdState(id);
  }, []);

  return { workstationId, setWorkstationId };
}
